import styled from "styled-components";
import PageTopTitle from "../../components/shared/PageTopTitle";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useRef, useState } from "react";
import Pagination from "../../components/shared/Pagination";
import { getDeleteUserRequestsForPortal } from "../../features/admin5/admin5Slice";

import SmallSpinner from "../../components/shared/spinners/SmallSpinner";
import InputText from "../../components/shared/input/new/InputText";
import InputSelect from "../../components/shared/input/new/InputSelect";
import InputDate from "../../components/shared/input/new/InputDate";

const approvalOptions = [
  {
    id: "all",
    text: "Tümü",
    value: null,
  },
  {
    id: "pending",
    text: "Bekleyen",
    value: false,
  },
  {
    id: "approved",
    text: "İşlenmiş / Onaylanmış",
    value: true,
  },
];

const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    color: ${({ theme }) => theme.mainTextColor};

    .top-container {
      margin: 30px;
      margin-bottom: 20px;
      background-color: #fff;
      border-radius: 24px;
      padding: 22px;
      border: 1px solid ${({ theme }) => theme.mainBorderColor};
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.04);

      .filter-header {
        margin-bottom: 24px;

        .header-content {
          display: flex;
          width: 100%;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
        }

        h3 {
          font-size: var(--font-size-md);
          font-weight: var(--font-weight-lg);
          color: ${({ theme }) => theme.mainTextColor};
        }

        .page-info {
          min-height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
          padding: 0 14px;
          border-radius: 8px;
          background-color: ${({ theme }) => theme.secondaryBgColor};
          border: 1px solid ${({ theme }) => theme.mainBorderColor};
          color: ${({ theme }) => theme.mainTextColor};
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-lg);
          white-space: nowrap;
        }
      }

      .filters {
        display: grid;
        grid-template-columns: repeat(4, minmax(180px, 1fr));
        gap: 18px;
      }

      .filter-bottom {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 14px;
        margin-top: 22px;

        button {
          min-width: 120px;
          height: 40px;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-lg);
          transition: 0.2s ease;
        }

        .clear-btn {
          background-color: #e85446;
          color: #fff;

          &:hover {
            opacity: 0.9;
          }
        }
      }
    }

    .list {
      margin: 0 30px;
      margin-top: 30px;
      display: flex;
      width: calc(100% - 60px);
      flex-direction: column;
      gap: 12px;

      .titles,
      .item-row {
        display: grid;
        grid-template-columns: 1.1fr 1.3fr 1.3fr 1fr 2fr 1.3fr;
        gap: 16px;
        align-items: center;
      }

      .titles {
        padding: 0 20px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);
        color: ${({ theme }) => theme.secondaryTextColor};

        span {
          white-space: nowrap;
        }
      }

      .item-row {
        background-color: ${({ theme }) => theme.secondaryBgColor};
        border: 1px solid ${({ theme }) => theme.mainBorderColor};
        border-radius: 18px;
        padding: 18px 20px;
        font-size: var(--font-size-sm);
        color: ${({ theme }) => theme.mainTextColor};
        transition: 0.2s ease;

        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.05);
        }

        .date {
          font-weight: var(--font-weight-lg);
        }

        .name {
          font-weight: var(--font-weight-lg);
        }

        .phone {
          white-space: nowrap;
        }

        .description {
          word-break: break-word;
          line-height: 1.45;
          color: ${({ theme }) => theme.mainTextColor};
        }

        .status {
          display: flex;
          align-items: center;
        }

        .status-badge {
          width: fit-content;
          padding: 7px 12px;
          border-radius: 999px;
          font-size: var(--font-size-sm);
          font-weight: var(--font-weight-lg);
          line-height: 1.3;
          white-space: normal;
        }

        .status-badge.approved {
          color: #1d7a3a;
          background-color: rgba(29, 122, 58, 0.12);
          border: 1px solid rgba(29, 122, 58, 0.2);
        }

        .status-badge.pending {
          color: #e85446;
          background-color: rgba(232, 84, 70, 0.12);
          border: 1px solid rgba(232, 84, 70, 0.2);
        }
      }

      .empty-text,
      .loading-text {
        min-height: 90px;
        padding: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.secondaryBgColor};
        border: 1px solid ${({ theme }) => theme.mainBorderColor};
        border-radius: 18px;
      }

      .loading-text {
        gap: 10px;
        font-weight: var(--font-weight-lg);
      }
    }

    .pagination-container {
      margin: 30px;
      display: flex;
      justify-content: center;
    }
  }

  @media (max-width: 1200px) {
    .wrapper {
      .top-container {
        .filters {
          grid-template-columns: repeat(3, minmax(180px, 1fr));
        }
      }
    }
  }

  @media (max-width: 900px) {
    .wrapper {
      .top-container {
        .filter-header {
          .header-content {
            align-items: flex-start;
            flex-direction: column;
          }
        }

        .filters {
          grid-template-columns: repeat(2, minmax(160px, 1fr));
        }

        .filter-bottom {
          justify-content: flex-start;
          flex-wrap: wrap;
        }
      }

      .list {
        overflow-x: auto;

        .titles,
        .item-row {
          min-width: 1050px;
        }
      }
    }
  }

  @media (max-width: 600px) {
    .wrapper {
      .top-container {
        margin: 20px;
        padding: 18px;

        .filter-header {
          .page-info {
            width: 100%;
          }
        }

        .filters {
          grid-template-columns: 1fr;
        }

        .filter-bottom {
          flex-direction: column;
          align-items: stretch;

          button {
            width: 100%;
          }
        }
      }

      .list {
        margin: 0 20px;
        margin-top: 25px;
        width: calc(100% - 40px);
      }

      .pagination-container {
        margin: 25px 20px;
      }
    }
  }
`;

const MobileDeletedAccounts = () => {
  const dispatch = useDispatch();
  const topRef = useRef();

  const [currentPage, setCurrentPage] = useState(1);

  const [pageSize, setPageSize] = useState("30");
  const [search, setSearch] = useState("");
  const [userName, setUserName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [adSoyadUnvan, setAdSoyadUnvan] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isApproved, setIsApproved] = useState(approvalOptions[0]);

  const [debouncedFilters, setDebouncedFilters] = useState({
    PageSize: 30,
    Search: "",
    UserName: "",
    PhoneNumber: "",
    AdSoyadUnvan: "",
    StartDate: "",
    EndDate: "",
  });

  const {
    isLoadingGetDeleteUserRequestsForPortal,
    deleteUserRequestsForPortalSize,
    deleteUserRequestsForPortalCount,
    deleteUserRequestsForPortalList,
  } = useSelector((state) => state.admin5);

  const normalizePageSize = (value) => {
    const numberValue = Number(value);

    if (!numberValue || numberValue < 1) return 10;
    if (numberValue > 100) return 100;

    return numberValue;
  };

  const getIsApprovedValue = (value) => {
    if (typeof value === "object" && value !== null) {
      return value.value;
    }

    if (typeof value === "string") {
      const foundOption = approvalOptions.find(
        (item) => item.text.toLowerCase() === value.toLowerCase()
      );

      return foundOption?.value ?? null;
    }

    return null;
  };

  const isSameFilter = (prev, next) => {
    return (
      prev.PageSize === next.PageSize &&
      prev.Search === next.Search &&
      prev.UserName === next.UserName &&
      prev.PhoneNumber === next.PhoneNumber &&
      prev.AdSoyadUnvan === next.AdSoyadUnvan &&
      prev.StartDate === next.StartDate &&
      prev.EndDate === next.EndDate
    );
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      const nextFilters = {
        PageSize: normalizePageSize(pageSize),
        Search: search,
        UserName: userName,
        PhoneNumber: phoneNumber,
        AdSoyadUnvan: adSoyadUnvan,
        StartDate: startDate,
        EndDate: endDate,
      };

      setCurrentPage(1);

      setDebouncedFilters((prev) => {
        if (isSameFilter(prev, nextFilters)) {
          return prev;
        }

        return nextFilters;
      });
    }, 500);

    return () => clearTimeout(timeout);
  }, [
    pageSize,
    search,
    userName,
    phoneNumber,
    adSoyadUnvan,
    startDate,
    endDate,
  ]);

  const createPayload = useCallback(() => {
    const payload = {
      Page: currentPage,
      PageSize: debouncedFilters.PageSize,
      Search: debouncedFilters.Search?.trim(),
      UserName: debouncedFilters.UserName?.trim(),
      PhoneNumber: debouncedFilters.PhoneNumber?.trim(),
      AdSoyadUnvan: debouncedFilters.AdSoyadUnvan?.trim(),
      StartDate: debouncedFilters.StartDate?.trim(),
      EndDate: debouncedFilters.EndDate?.trim(),
      IsApproved: getIsApprovedValue(isApproved),
    };

    return Object.fromEntries(
      Object.entries(payload).filter(
        ([, value]) => value !== "" && value !== null && value !== undefined
      )
    );
  }, [currentPage, debouncedFilters, isApproved]);

  useEffect(() => {
    dispatch(getDeleteUserRequestsForPortal(createPayload()));
  }, [dispatch, createPayload]);

  const totalPages = Math.ceil(
    (deleteUserRequestsForPortalCount || 0) /
      (deleteUserRequestsForPortalSize || debouncedFilters.PageSize || 10)
  );

  const visibleTotalPages = totalPages > 0 ? totalPages : 1;
  const totalCount = deleteUserRequestsForPortalCount || 0;

  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleString("tr-TR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const formatStatus = (item) => {
    if (!item?.isApproved) {
      return "Hayır";
    }

    return item.approvedDate
      ? `Evet (${formatDate(item.approvedDate)})`
      : "Evet";
  };

  const handleIsApprovedChange = (value) => {
    setCurrentPage(1);
    setIsApproved(value);
  };

  const handleClearFilters = () => {
    setPageSize("30");
    setSearch("");
    setUserName("");
    setPhoneNumber("");
    setAdSoyadUnvan("");
    setStartDate("");
    setEndDate("");
    setIsApproved(approvalOptions[0]);
    setCurrentPage(1);

    setDebouncedFilters((prev) => {
      const nextFilters = {
        PageSize: 30,
        Search: "",
        UserName: "",
        PhoneNumber: "",
        AdSoyadUnvan: "",
        StartDate: "",
        EndDate: "",
      };

      if (isSameFilter(prev, nextFilters)) {
        return prev;
      }

      return nextFilters;
    });
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);

    topRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"Mobil Uygulama Silenler"} position="sticky" />

        <div className="top-container" ref={topRef}>
          <div className="filter-header">
            <div className="header-content">
              <h3>Mobil Uygulama Silme Talepleri</h3>

              <div className="page-info">
                {isLoadingGetDeleteUserRequestsForPortal && (
                  <SmallSpinner
                    size={"20px"}
                    color={"#fff"}
                    bgColor={"#E85446"}
                  />
                )}

                <span>
                  Sayfa {currentPage} / {visibleTotalPages} ({totalCount} kayıt)
                </span>
              </div>
            </div>
          </div>

          <div className="filters">
            <InputText
              data={search}
              setData={(e) => setSearch(e.target.value)}
              name={"search"}
              labelText={"Genel Arama"}
            />

            <InputText
              data={userName}
              setData={(e) => setUserName(e.target.value)}
              name={"userName"}
              labelText={"Kullanıcı Adı"}
            />

            <InputText
              data={phoneNumber}
              setData={(e) => setPhoneNumber(e.target.value)}
              name={"phoneNumber"}
              labelText={"Telefon"}
            />

            <InputText
              data={adSoyadUnvan}
              setData={(e) => setAdSoyadUnvan(e.target.value)}
              name={"adSoyadUnvan"}
              labelText={"Ad Soyad / Ünvan"}
            />

            <InputDate
              data={startDate}
              setData={(e) => setStartDate(e.target.value)}
              name={"startDate"}
              labelText={"Başlangıç Tarihi"}
            />

            <InputDate
              data={endDate}
              setData={(e) => setEndDate(e.target.value)}
              name={"endDate"}
              labelText={"Bitiş Tarihi"}
              min={startDate}
            />

            <InputText
              data={pageSize}
              setData={(e) => setPageSize(e.target.value)}
              name={"pageSize"}
              labelText={"Sayfa Boyutu"}
            />

            <InputSelect
              data={typeof isApproved === "string" ? isApproved : isApproved?.text}
              setData={handleIsApprovedChange}
              initialOptions={approvalOptions}
              name={"isApproved"}
              labelText={"Onay Durumu"}
            />
          </div>

          <div className="filter-bottom">
            <button
              type="button"
              className="clear-btn"
              onClick={handleClearFilters}
            >
              Temizle
            </button>
          </div>
        </div>

        <div className="list">
          <div className="titles">
            <span>Tarih</span>
            <span>Ad Soyad</span>
            <span>Telefon</span>
            <span>Kullanıcı Adı</span>
            <span>Açıklama</span>
            <span>Durum</span>
          </div>

          {isLoadingGetDeleteUserRequestsForPortal ? (
            <div className="loading-text">
              <SmallSpinner size={"20px"} color={"#fff"} bgColor={"#E85446"} />
            </div>
          ) : deleteUserRequestsForPortalList?.length > 0 ? (
            deleteUserRequestsForPortalList.map((item) => (
              <div className="item-row" key={item.id || item.$id}>
                <span className="date">{formatDate(item.createOn)}</span>

                <span className="name">{item.adSoyadUnvan || "-"}</span>

                <span className="phone">{item.phoneNumber || "-"}</span>

                <span className="phone">{item.userName || "-"}</span>

                <span className="description">
                  {item.deleteDescription?.trim() || "-"}
                </span>

                <span className="status">
                  <span
                    className={`status-badge ${
                      item.isApproved ? "approved" : "pending"
                    }`}
                  >
                    {formatStatus(item)}
                  </span>
                </span>
              </div>
            ))
          ) : (
            <div className="empty-text">Kayıt bulunamadı.</div>
          )}
        </div>

        <div className="pagination-container">
          {deleteUserRequestsForPortalList?.length > 0 && totalPages > 1 && (
            <Pagination
              totalPages={totalPages}
              handleClick={handlePageChange}
              currentPage={currentPage}
            />
          )}
        </div>
      </div>
    </Container>
  );
};

export default MobileDeletedAccounts;